import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/bff-prompts';

@Injectable({
  providedIn: 'root',
})
export class CadastroPromptService {
  constructor(private apiService: ApiService) {}

  cadastrarPrompt(promptData: any): Observable<any> {
    return this.apiService.post('prompt/', promptData);
  }

  atualizarPrompt(promptData: any): Observable<any> {
    return this.apiService.put('prompt/', promptData);
  }

  contadorExecucaoPrompt(idPrompt: any): Observable<any> {
    return this.apiService.postId('prompt/'+ idPrompt +'/execucao', '');
  }

  categoriaPrompt(): Observable<any> {
    return this.apiService.get('categoria/');
  }
}
